export { setAppElementForBaseModal } from './lib/base-modal';
export * from './lib/modal';
export * from './lib/client-only-modal';
export * from './lib/modal.mocks';
